import { render, staticRenderFns } from "./rankingChart.vue?vue&type=template&id=70c7e960&scoped=true"
import script from "./rankingChart.vue?vue&type=script&lang=js"
export * from "./rankingChart.vue?vue&type=script&lang=js"
import style0 from "./rankingChart.vue?vue&type=style&index=0&id=70c7e960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c7e960",
  null
  
)

export default component.exports